module.exports = __webpack_public_path__ + "img/logo-cer-02.5369c809.png";